import React from "react";
import useEntity from "../../../hooks/useUserSession";
import {
    Box, 
    Paper, 
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Typography,
    Link,
    TableSortLabel,
} from "@mui/material";
import { visuallyHidden } from '@mui/utils';
import { CheckBoxOutlined as CheckBoxOutlinedIcon, CheckBoxOutlineBlankOutlined as CheckBoxOutlineBlankOutlinedIcon } from "@mui/icons-material";
import {ID} from "../../../../types/global.d";
import EntityListHeader from "./UserSessionListHeader";
import EntityListSearch from "./UserSessionListSearch";
import {useLocation} from "react-router";
import UserSessionListPagination from "./UserSessionListPagination";
import * as Api from "../../../apis/UserSession.api";
import { UserSession } from "../../../types/models/UserSession";
import { PrimaryUserSession } from "../../../types/models/UserSession";
import { usePagination } from '../../../../share';
import {displayDateTime, displayDate, displayTime} from "../../../../utils/formatDate.ts";
import {percentageFormat, fixedFormat, currencyFormat} from "../../../../utils/numberFormat";

import UserLink from "../../../../auth/components/user/UserDetail/UserLink";
import UserName from "../../../../auth/components/user/UserDetail/UserName";
import MembersGroupLink from "../../../../auth/components/membersGroup/MembersGroupDetail/MembersGroupLink";
import MembersGroupName from "../../../../auth/components/membersGroup/MembersGroupDetail/MembersGroupName";
import { toStringDisplay as toStringGroupType } from "../../../types/models/GroupType.d";

import { PrimaryUser } from "../../../../auth/types/models/User";
import {useTheme} from "@mui/material/styles";
import useSearchDebounce from "../../../../hooks/useSearchDebounce";
import UserSessionListItemTools from "./UserSessionListItemTools";
import {useStateSession} from "../../../../hooks/useAuth";
import GradientCircularProgress from "../../../../share/components/progress/GradientCircularProgress";

import useMediaQuery from '@mui/material/useMediaQuery';
import { Trans } from "@lingui/react/macro";
import {
    mdiLinkVariant,
} from "@mdi/js";
import {
    StyledFillNavLink,
    ToolbarTableCell,
    BigTableRow,
    BigTableHeaderRow,
    SmallTableRow,
    SmallTableHeaderRow,
    StyledTableCell,
    StyledMdiIcon,
} from "../../../../share/components/styled/Table";
import {OrderBy, OrderDirection} from "../../../../types/global.d";

type IProps = {
    showAdd: boolean,
    userId?: ID,
    };

const UserSessionListItem = (props: IProps) => {
    const theme = useTheme();
    const isSmallScreen = useMediaQuery(theme.breakpoints.down('lg'));
    
    const session = useStateSession()
    const {showAdd, ...query} = props;

    const { page, pageSize, handleChangePage, handleChangePageSize } = usePagination('UserSession')

    
    
    
    
    

    const [orderBys, setOrderBys] = React.useState<OrderBy[]>([]);

    const toggleOrder = React.useCallback((name: string) => {
        setOrderBys(prev => {
            const current = prev.find(item => item.name === name)
            return [
                {
                    name,
                    direction: current?.direction === OrderDirection.Asc ? OrderDirection.Desc : OrderDirection.Asc
                },
                ...(prev.filter(item => item.name !== name))
            ]
        });
    }, []);

    const { data: dataSimple = {
        items: [],
        totalItems: 0,
        page,
        pageSize,
        numPages: 0
    }, 
        isLoading: isLoadingSimple,
        isFetching: isFetchingSimple,
        refetch: refetchSimple,
    } =
          Api.useGetUserSessionPresentationQuery({
                  list: { page, pageSize },
                  filter: {
                    userIdRefs: (PrimaryUser.fromQuery(query.userId)) ? [ PrimaryUser.fromQuery(query.userId) ] : [],
                    orderBys,
                  },
              })
    
    const {data, isLoading, isFetching, refetch} =
        {
                data: dataSimple,
                isLoading: isLoadingSimple,
                isFetching: isFetchingSimple,
                refetch: refetchSimple,
            }

    const routeLocation = useLocation();
    
    const onClickUrl = (entity: UserSession) => routeLocation.pathname.endsWith('user-sessions') ?
        `${PrimaryUserSession.fromEntity(entity).toPath()}`
        :
        `user-sessions/${PrimaryUserSession.fromEntity(entity).toPath()}`

    const onEditUrl = (entity: UserSession) => `${onClickUrl(entity)}/edit`

    
    
    return React.useMemo(() => (
        <Box>
            <Paper>
                <EntityListHeader showAdd={showAdd} {...query}/>
                
                <TableContainer>

                    

                    

                    

                    

                    
        
                    
                    {isSmallScreen ?
                        <Table stickyHeader data-testid="UserSession-entity-list" size="small">
                            <TableHead>
                                <SmallTableHeaderRow>
                                    
                                        
                                        
                                    

                                    
                            { query.userId ?
                                <></>
                                :
                            
                                <StyledTableCell align="left">
                                    
                                    <TableSortLabel
                                        active={ orderBys.find((item) => item.name === 'userId') }
                                        direction={ orderBys.find((item) => item.name === 'userId')?.direction || 'asc' }
                                        onClick={() => toggleOrder('userId')}
                                    >
                                    
                                        <Trans>User</Trans>
                                    
                                    </TableSortLabel>
                                    
                                </StyledTableCell>
                            }
                            
                        
                    
                                    
                                    
                            <StyledTableCell align="center">
                                
                                <TableSortLabel
                                    active={ orderBys.find((item) => item.name === 'createdAt') }
                                    direction={ orderBys.find((item) => item.name === 'createdAt')?.direction || 'asc' }
                                    onClick={() => toggleOrder('createdAt')}
                                >
                                
                                    <Trans>Created At</Trans>
                                
                                </TableSortLabel>
                                
                            </StyledTableCell>
                        
                    
                                    
                                    
                                </SmallTableHeaderRow>
                            </TableHead>
                            <TableBody>
                                { data.items.map((item) => (
                                    <SmallTableRow
                                        hover={true}
                                        key={ PrimaryUserSession.fromEntity(item).toPath() }
                                    >
                                        
                        
                        
                            
                            
                        
                        { query.userId ? <></> :
                        

                        <TableCell
                            scope="row"
                            align="left"
                        >
                            <Link
                                component={StyledFillNavLink}
                                to={ onClickUrl(item) }
                                viewTransition={true}
                            >
                            
                                <Typography component="div" sx={ { fontWeight: 'bold', } }>
                                    { item.userId ?
                                        <>
                                            
                        
                        
                        <UserName id={ item.userId }/>
                        
                        
                    
                                        </>
                                        :
                                        '-'
                                    }
                                </Typography>
                                
                            
                            </Link>
                        </TableCell>
                        }
                        

                    
                        
                    
                        
                        <TableCell
                            scope="row"
                            align="center"
                            
                        >
                            
                            <Link
                                component={StyledFillNavLink}
                                to={ onClickUrl(item) }
                                viewTransition={true}
                            >
                            
                            
                        
                        {displayDateTime(item.createdAt) }
                        
                    
                            
                            </Link>
                            
                        </TableCell>
                        
                    
                        
                    
                        
                    
                                    </SmallTableRow>
                                ))}
                            </TableBody>
                        </Table>
                        :
                    
                        <Table stickyHeader data-testid="UserSession-entity-list" size="small">
                            <TableHead>
                                <BigTableHeaderRow>
                                    
                                    
                                    
                                    { query.userId ?
                                        <></>
                                        :
                                        <StyledTableCell align="left">
                                            
                                            <TableSortLabel
                                                active={ orderBys.find((item) => item.name === 'userId') }
                                                direction={ orderBys.find((item) => item.name === 'userId')?.direction || 'asc' }
                                                onClick={() => toggleOrder('userId')}
                                            >
                                            
                                                <Trans>User</Trans>
                                            
                                            </TableSortLabel>
                                            
                                        </StyledTableCell>
                                    }
                                    
                                    
                                    
                                    
                                    
                                    
                                    
                                    
                                    <StyledTableCell align="left">
                                        
                                        <TableSortLabel
                                            active={ orderBys.find((item) => item.name === 'device') }
                                            direction={ orderBys.find((item) => item.name === 'device')?.direction || 'asc' }
                                            onClick={() => toggleOrder('device')}
                                        >
                                        
                                            <Trans>Device</Trans>
                                        
                                        </TableSortLabel>
                                        
                                    </StyledTableCell>
                                    
                                    
                                    
                                    
                                    <StyledTableCell align="center">
                                        
                                        <TableSortLabel
                                            active={ orderBys.find((item) => item.name === 'createdAt') }
                                            direction={ orderBys.find((item) => item.name === 'createdAt')?.direction || 'asc' }
                                            onClick={() => toggleOrder('createdAt')}
                                        >
                                        
                                            <Trans>Created At</Trans>
                                        
                                        </TableSortLabel>
                                        
                                    </StyledTableCell>
                                    
                                    
                                    
                                    
                                    
                                    
                                </BigTableHeaderRow>
                            </TableHead>
                            <TableBody>
                                { data.items.map((item) => (
                                    <BigTableRow
                                        hover={true}
                                        key={ PrimaryUserSession.fromEntity(item).toPath() }
                                    >
                                        
                                        
                                        
                        { query.userId ? <></> :
                        
                        <TableCell
                            scope="row"
                            align="left"
                            
                        >
                            
                            
                        
                        
                        <UserLink id={ item.userId } icon={<StyledMdiIcon d={mdiLinkVariant} />}/>
                        
                        
                    
                            
                        </TableCell>
                        
                        }
                        
                    
                                        
                                        
                                        
                                        
                                        
                                        
                                        
                                        
                        <TableCell
                            scope="row"
                            align="left"
                            
                        >
                            
                            <Link
                                component={StyledFillNavLink}
                                to={ onClickUrl(item) }
                                viewTransition={true}
                            >
                            
                            
                        
                        { item.device || '-' }
                        
                    
                            
                            </Link>
                            
                        </TableCell>
                        
                    
                                        
                                        
                                        
                                        
                        <TableCell
                            scope="row"
                            align="center"
                            
                        >
                            
                            <Link
                                component={StyledFillNavLink}
                                to={ onClickUrl(item) }
                                viewTransition={true}
                            >
                            
                            
                        
                        {displayDateTime(item.createdAt) }
                        
                    
                            
                            </Link>
                            
                        </TableCell>
                        
                    
                                        
                                        
                                        
                                        
                                        
                                        <ToolbarTableCell align="center" width="15%">
                                            <UserSessionListItemTools data={ item }
                                                                               onClickUrl={onClickUrl(item)} onEditUrl={onEditUrl(item)}
                                                                                />
                                        </ToolbarTableCell>
                                    </BigTableRow>
                                ))}
                            </TableBody>
                        </Table>
                    }
                    
            
                    { !data.totalItems && !isLoading && !isFetching &&
                        <Typography
                            sx={ { flex: '1 1 100%', padding: "2em", } }
                            component="div"
                        >
                            <Trans>No User Sessions</Trans>
                        </Typography>
                    }
                    { (isLoading || isFetching) &&
                        <GradientCircularProgress/>
                    }
                </TableContainer>
                <UserSessionListPagination
                    totalItems={ data.totalItems }
                    page={Number(page)}
                    pageSize={pageSize}
                    handleChangePage={handleChangePage}
                    handleChangePageSize={handleChangePageSize}
                />
            </Paper>
        </Box>
    ), [isLoading, isFetching,isSmallScreen, data, page, pageSize, onClickUrl,  onEditUrl])
}

export default UserSessionListItem;
